<template>
  <div class="sm:relative">
    <button
      type="button"
      class="flex cursor-pointer items-center hover:text-brand-500"
      @click="show = !show"
    >
      <slot></slot>
    </button>
    <div
      class="absolute left-0 right-0 z-50 mx-4 mt-3 flex flex-col overflow-hidden whitespace-nowrap rounded bg-white pt-3 shadow sm:-mx-3"
      v-if="show"
    >
      <div class="flex flex-col px-5 py-1">
        <span class="mb-1 text-sm">{{ $t('activity.from') }}</span>
        <div class="relative flex items-center">
          <span class="far fa-calendar-alt absolute left-0 ml-4 text-base" />
          <date-picker
            name="start"
            v-model="currentStart"
            class="form-input w-full pl-10"
            required
          />
        </div>
        <span class="mt-3 mb-1 text-sm">{{ $t('activity.until') }}</span>
        <div class="relative flex items-center">
          <span class="far fa-calendar-alt absolute left-0 ml-4 text-base" />
          <date-picker name="end" v-model="currentEnd" class="form-input w-full pl-10" required />
        </div>
        <div class="mt-4" v-if="presets">
          <button
            type="button"
            class="text-sm text-gray-500 hover:text-black"
            @click="showPresets = !showPresets"
          >
            Presets
            <span class="fal" :class="[showPresets ? 'fa-angle-up' : 'fa-angle-down']" />
          </button>
          <div class="flex flex-col items-start text-sm" v-if="showPresets">
            <a
              :href="createPath(preset.start, preset.end)"
              class="text-brand-500 hover:text-brand-800"
              v-for="preset in presets"
              :key="preset.name"
            >
              {{ preset.name }}
            </a>
          </div>
        </div>
      </div>
      <div class="mt-3 flex justify-end bg-gray-100 p-2 text-sm">
        <a
          :href="createPath(currentStart, currentEnd)"
          class="flex items-baseline rounded bg-brand-500 px-3 py-1 text-white hover:bg-brand-800 hover:text-brand-100"
          ref="submitButton"
        >
          <span class="far fa-check mr-1" />
          {{ $t('global.apply') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
export default {
  props: {
    path: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    presets: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      show: false,
      showPresets: false,
      currentStart: this.start,
      currentEnd: this.end,
    }
  },
  watch: {
    show(show) {
      if (show) {
        document.addEventListener('click', this.closeIfClickedOutside)
      } else {
        document.removeEventListener('click', this.closeIfClickedOutside)
      }
    },
  },
  methods: {
    createPath(start, end) {
      return this.path
        .replace(':start', start < end ? start : end)
        .replace(':end', end > start ? end : start)
    },
    selectPreset(preset) {
      this.currentStart = preset.start
      this.currentEnd = preset.end

      nextTick(() => {
        this.$refs.submitButton.click()
      })
    },
    closeIfClickedOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.show = false
      }
    },
  },
}
</script>
